import { render } from "./component-scx.vue?vue&type=template&id=62f95c46"
import script from "./component-scx.vue?vue&type=script&lang=js"
export * from "./component-scx.vue?vue&type=script&lang=js"

import "./component-scx.vue?vue&type=style&index=0&id=62f95c46&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__